import React from "react"
import LoginMember from "../components/auth/LoginMember"

const Login = () => {
  return <LoginMember></LoginMember>
}

export default Login